<template>
  <div class="p-0" style="width: 100%; height: 100%; display: flex; flex-direction: column; min-height: 0px;">

    <v-card class="rounded-lg mb-2 pa-2" elevation="1">
      <v-row align="start" justify="space-between">

        <v-col cols="12" md="8" class="d-flex align-center">
          <v-avatar color="deep-purple lighten-4" size="60" class="mr-6">
            <span class="deep-purple--text text--darken-2 text-h5 font-weight-bold">{{displayNameAbreviation}}</span>
          </v-avatar>

          <div>
            <h1 class="text-h5 font-weight-medium mb-1">{{displayMita+ ' - Überstundenverrechnung ' +monthName + ', ' + date.split('-')[0]}}</h1>
            <div class="subtitle-1 grey--text text--darken-1 mb-3 d-flex align-center">
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-domain</v-icon>
                Kostenstelle: &nbsp;<b>{{' ' + displayKost}}</b>
              </v-chip>
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-account-multiple</v-icon>
                Mitarbeitergruppe: &nbsp;<b>{{' ' + displayMigr}}</b>
              </v-chip>
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-calendar-range</v-icon>
                Eintrittsdatum: &nbsp;<b>{{' ' + displayEntryDate}}</b>
              </v-chip>
            </div>

            <!--div class="d-flex flex-wrap" style="gap: 8px">
            </div-->
          </div>
        </v-col>

        <v-col cols="12" md="4" class="d-flex justify-md-end">
          <v-sheet
              color="deep-purple lighten-5"
              class="rounded-lg pa-3"
              width="100%"
              max-width="300"
          >
            <div class="d-flex justify-space-between mb-2 text-body-2">
              <span class="font-weight-bold">Soll</span>
              <span class="font-weight-bold">{{displayHoures(soll)}}</span>
            </div>
            <div class="d-flex justify-space-between mb-2 text-body-2">
              <span class="font-weight-bold">Ist</span>
              <span class="font-weight-bold">{{displayHoures(ist)}}</span>
            </div>
            <v-divider style="margin-top: 4px; margin-bottom: 4px"></v-divider>
            <div class="d-flex justify-space-between text-body-2">
              <span class="font-weight-bold">Saldo</span>
              <span class="font-weight-bold">{{displayHoures(saldo)}}</span>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="rounded-lg" elevation="1" style="height: 100%; max-height: 100%">
      <v-card-title class="text-subtitle-1 font-weight-bold px-6 pt-5">
        Übersicht: {{displayHoures(uebToBook)}} Std. zuschlagspflichtige Überstunden in diesem Monat

        <v-btn
            elevation="2"
            small
            class="ml-auto"
            color="success"
            style="margin-right: 8px"
            :disabled="uebToBook === 0 || !canBook"
            @click="book"
        > <v-icon left>
          mdi-cash-check
        </v-icon>
          {{ displayHoures(uebToBook) + ' Zuschläge buchen' }}</v-btn>
      </v-card-title>

      <v-simple-table id="printable-area"  class="mx-2 pb-2" style="border-top: thin solid #E0E0E0"
                      fixed-header ref="vuetifyTable" height="calc(100vh - 280px)">
        <template v-slot:default>
          <thead>
          <tr>
            <th colspan="2" class="text-center fixed-width">Monat</th>

            <th colspan="3" class="text-center group-header">Arbeitszeit</th>

            <th colspan="3" class="text-center group-header">Saldo</th>

            <th colspan="1" class="text-center group-header">abgefeiert</th>
            <th colspan="1" class="text-center group-header">Überstunden</th>
          </tr>
          <tr>
            <th class="text-center sub-header" style="width: 70px"></th>
            <th class="text-center sub-header" style="width: 70px"></th>

            <th class="text-center sub-header">Soll</th>
            <th class="text-center sub-header">Ist</th>
            <th class="text-center sub-header">Üb. in RB</th>

            <th class="text-center sub-header">Geleisted</th>
            <th class="text-center sub-header">Abgefeiert</th>
            <th class="text-center sub-header">Saldo</th>
            <th class="text-center sub-header">in Folge</th>
            <th class="text-center sub-header">je Woche</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, i) in calendar_weeks">
            <tr :key="'header' + i" class="header-footer-row b-top">
              <td class="font-weight-medium pl-6 " style="border-left: thin solid #E0E0E0">KW</td>
              <td class="font-weight-medium pl-6  " style="border-left: thin solid #E0E0E0">{{item.week}}</td>
              <td v-for="index in 8" :key="index" class="text-right" >
                <span class="grey--text text--lighten-2"></span>
              </td>
            </tr>
            <tr v-for="(day, j) in item.days" :key="'item' + i + j" class="hover-row b-top" >
            <td class="font-weight-medium pl-6  header-footer-row" style="border-left: thin solid #E0E0E0">{{ day.date.split('-')[2] }}</td>
            <td class="font-weight-medium pl-6 header-footer-row" style="border-left: thin solid #E0E0E0">{{ getWeekday(day.date) }}</td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.soll !== 0}">{{displayHoures(day.soll)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.ist !== 0}">{{displayHoures(day.ist)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.rb !== 0}">{{displayHoures(day.rb)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.ueb_geleistet !== 0}">{{displayHoures(day.ueb_geleistet)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.ueb_abgebaut !== 0}">{{displayHoures(day.ueb_abgebaut)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.saldo_ueb !== 0}">{{displayHoures(day.saldo_ueb)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text " :class="{'text--darken-4': day.abgebaut_next_week !== 0}">{{displayHoures(day.abgebaut_next_week)}}</span>
              </td>
              <td class="text-right" :class="{'col-not-in-month': day.date.split('-')[1] !== date.split('-')[1]}">
                <span class="grey--text" :class="{'text--darken-4': (day.saldo_ueb - day.abgebaut_next_week) !== 0}">{{displayHoures(day.saldo_ueb - day.abgebaut_next_week < 0 ? 0 : day.saldo_ueb - day.abgebaut_next_week)}}</span>
              </td>
          </tr>
            <tr :key="'footer' + i" class=" header-footer-row b-top">
              <td class="font-weight-medium pl-6  " style="border-left: thin solid #E0E0E0"></td>
              <td class="font-weight-medium pl-6  " style="border-left: thin solid #E0E0E0">⌀</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_soll) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_ist) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_rb) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_ueb_geleistet) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_uen_abgebaut) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.saldo_ueb) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_ueb_abgebaut_next_week) }}</td>
              <td class="text-right font-weight-bold" style="" :class="{
                    'text--darken-2': true,
                  }">{{ displayHoures(item.sum_resulting_ueb) }}</td>
            </tr>
          </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {get} from "immutable";

export default {
  name: "UebOverview",
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    currentMode: {
      type: String,
      default () {
        return "month";
      }
    },
    currentMita: {
      type: String,
      default: () => undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    mitasFlat: {
      type: Array,
      default: () => []
    },
  },
  components: {
  },
  mounted() {
    window.addEventListener('resize', this.calculateWidth);
    if (this.currentMita) {
      this.queryData()
    }
  },
  beforeDestroy() {
  },
  watch: {
    date: function (newDate) {
      this.canBook = true;
      if (this.currentMita) {
        this.queryData()
      } else {
        // todo clear data
      }
    },
    currentMita: function (newDate) {
      this.canBook = true;
      if (this.currentMita) {
        this.queryData()
      } else {
        // todo clear data
      }
    },
  },
  computed: {
    monthName() {
      let month = this.date.split('-')[1];
      return this.months[parseInt(month) - 1];
    },
    numberDaysInMonth() {
      let date = new Date(this.date);
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    },
    displayMita() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.name : "Kein Mitarbeiter ausgewählt";
    },
    displayId() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.bis_id : "000000";
    },
    displayMigr() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.migr : "";
    },
    displayKost() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.kost : "";
    },
    displayEntryDate() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? (mita.start_date ? mita.start_date : 'Nicht gesetzt') : "";
    },
    displayNameAbreviation() {
      let mita = this.getCurrentMita(this.currentMita);
      if (mita && mita.name) {
        let names = mita.name.split(' ');
        if (names.length >= 2) {
          return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
        } else if (names.length === 1) {
          return names[0].charAt(0).toUpperCase();
        }
      }
      return "";
    },
    soll() {
      let soll = 0.0;
      for (let i = 0; i < this.calendar_weeks.length; i++) {
        for (let j = 0; j < this.calendar_weeks[i].days.length; j++) {
          if (this.date.split('-')[1] === this.calendar_weeks[i].days[j].date.split('-')[1]) {
            soll += this.calendar_weeks[i].days[j].soll;
          }
        }
      }
      return soll
    },
    ist() {
      let ist = 0.0;
      for (let i = 0; i < this.calendar_weeks.length; i++) {
        for (let j = 0; j < this.calendar_weeks[i].days.length; j++) {
          if (this.date.split('-')[1] === this.calendar_weeks[i].days[j].date.split('-')[1]) {
            ist += this.calendar_weeks[i].days[j].ist;
          }
        }
      }
      return ist
    },
    saldo() {
      return this.ist - this.soll;
    },
    uebToBook() {
      let toBook = 0;
      for (let i = 0; i < this.calendar_weeks.length; i++) {
        for (let j = 0; j < this.calendar_weeks[i].days.length; j++) {
          if (this.date.split('-')[1] === this.calendar_weeks[i].days[j].date.split('-')[1] && this.calendar_weeks[i].days[j].saldo_ueb > 0) {
            toBook += this.calendar_weeks[i].days[j].saldo_ueb - this.calendar_weeks[i].days[j].abgebaut_next_week;
          }
        }
      }
      return toBook;
    },
    displayVpExtern() {
      let mita = this.getCurrentMita(this.currentMita);
      if (!mita) {
        return "";
      }
      let vp = mita.price_ext;
      vp = vp.replace('EUR', '').replace('EU', '').replace('.', ',').replace('€', '').replace(',', '.').trim();
      // bring to 2 digits after comma
      vp = parseFloat(vp).toFixed(2);
      return (vp + '').replace('.', ',') + " €";
    },
  },
  data: () => ({
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    weekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    calendar_weeks: [],
    canBook: true,
  }),
  methods: {
    book() {
      let bookings = [];
      for (let i = 0; i < this.calendar_weeks.length; i++) {
        for (let j = 0; j < this.calendar_weeks[i].days.length; j++) {
          if (this.date.split('-')[1] === this.calendar_weeks[i].days[j].date.split('-')[1] && this.calendar_weeks[i].days[j].saldo_ueb > 0) {
            let bookHours = this.calendar_weeks[i].days[j].saldo_ueb - this.calendar_weeks[i].days[j].abgebaut_next_week;
            if (bookHours > 0) {
              bookings.push({
                date: this.calendar_weeks[i].days[j].date,
                hours: bookHours
              });
            }
          }
        }
      }
      if (bookings.length > 0) {
        this.showLoader();
        let mita = this.getCurrentMita(this.currentMita);
        this.canBook = false;
        this.$http.post(
            Server_URL_ZK + '/zk/ueb_surcharge/' + mita.bis_id + "?year=" + this.date.split('-')[0] + "&month=" + this.date.split('-')[1],
            bookings
        ).then(this.responseOkTrap, this.responseError)
      }
    },
    getWeekday(d) {
      const date = new Date(parseInt(d.split('-')[0]), parseInt(d.split('-')[1]) - 1, parseInt(d.split('-')[2]));
      return this.weekdays[date.getDay()]; // 0 (Sunday) to 6 (Saturday)
    },
    truncateString(str) {
      let maxLength = 20;
      if (str.length > maxLength) {
        return str.slice(0, maxLength - 3) + '...';
      }
      return str;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    queryData() {
      let mita = this.getCurrentMita(this.currentMita);
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/ueb_surcharge/' + mita.bis_id + "?year=" + this.date.split('-')[0] + "&month=" + this.date.split('-')[1]
      ).then(this.responseOkGetIsoWeeks, this.responseError)
    },
    responseOkGetIsoWeeks(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.calendar_weeks = response.body;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200) {
      } else {
        window.location = Redirect_500;
      }
    },

    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    displayNumber(num, unit) {
      if (num === 1) {
        // singular, remove trailing e if exists
        unit = unit.replace(/e(n)?$/i, '');
      }
      return (num + '').replace('.', ',') + ' ' + unit;
    },
    displayFloat(num, unit = '') {
      num = parseFloat(num).toFixed(2);
      return (num + '').replace('.', ',') + ' ' + unit;
    },
    displayHoures(num) {
      if (!num && num !== 0) {
        return '';
      }
      let isNegative = num < 0;
      num = Math.abs(num);
      let hours = Math.floor(num);
      let minutes = (Math.round((num - hours) * 60) + '').padStart(2, '0');
      if (isNegative) {
        hours = '-' + hours;
      }
      return `${hours}:${minutes}`;
    },
    sumArray(arr) {
      return arr.reduce((a, b) => a + b, 0);
    }
  }

}
</script>

<style scoped>
/* Custom styling to ensure the table looks clean */
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.75rem !important;
  color: #757575 !important;
}

/* Light hover effect */
.hover-row:hover {
  background-color: #f5f5f5 !important;
}

.header-footer-row {
  background-color: #e0e0e0 !important;
}

.col-not-in-month {
  background-color: #eeeeee !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 32px !important;
}

.table-divider {
  border-bottom: solid 2px #7c7c7c !important;
  border-top: solid 2px #7c7c7c !important;
}

.table-divider-l {
  border-left: solid 2px #7c7c7c !important;
  border-right: solid 2px #7c7c7c !important;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) ;
}


::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-right: thin solid rgba(0, 0, 0, 0.12) ;
}


::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-right: thin solid #E0E0E0 !important;

}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-left: thin solid #E0E0E0 !important;
}

.top-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  height: 20px; /* Needed for scrollbar visibility */
}

.dummy-content {
  height: 1px;
}


/* 1. Target both the Top Dummy Scroll and the Vuetify Table Wrapper */
.top-scroll,
::v-deep .v-data-table__wrapper {
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #90A4AE #CFD8DC; /* thumb color, track color */
}

/* 2. WebKit Browsers (Chrome, Edge, Safari) */

/* The Scrollbar container */
.top-scroll::-webkit-scrollbar,
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px; /* Height for horizontal scrollbar */
  width: 10px;  /* Width for vertical scrollbar */
}

/* The Track (background) */
.top-scroll::-webkit-scrollbar-track,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #CFD8DC; /* Light grey track */
  border-radius: 4px;
}

/* The Thumb (the moving handle) */
.top-scroll::-webkit-scrollbar-thumb,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #90A4AE; /* Darker grey handle */
  border-radius: 4px; /* Rounded corners */
  border: 2px solid #CFD8DC; /* Creates a 'padding' effect around the thumb */
}

/* Hover effect for the thumb */
.top-scroll::-webkit-scrollbar-thumb:hover,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #607D8B; /* Darken on hover */
}

/* --- Layout Styles (From previous step) --- */
.top-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  /* Match the height defined in ::-webkit-scrollbar height + a little buffer if needed */
  height: 14px;
}
.dummy-content {
  height: 1px;
}

.table-style {
  position: sticky;
  left: 0;
  z-index: 6 !important;
  background-color: white;
}

</style>

<style scoped>
/* Table Border Styling to match the strict grid look */
.timesheet-table >>> table {
  border-collapse: collapse;
}

.timesheet-table >>> th,
.timesheet-table >>> td {
  border: 1px solid #e0e0e0;
  padding: 0 8px !important;
}

/* Header Styling */
.group-header {
  background-color: #f5f5f5;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}

.sub-header {
  font-size: 0.75rem;
  color: #666;
}

/* Row Coloring */
.row-weekend {
  background-color: #ffff99 !important; /* Yellow */
}

.row-weekend:hover {
  background-color: #ffff66 !important;
}

.row-holiday {
  background-color: #ffcccc !important; /* Light Red */
}

.row-holiday:hover {
  background-color: #ffaaaa !important;
}

/* Column Width Adjustments */
.fixed-width {
  width: 80px;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  text-decoration: underline;
  text-decoration-style: solid;
}

</style>
